import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import MemberHeader from "@/components/MemberHeader";
import { PlanCard } from "@/pages/MemberArea";

function Section({ title, plans, empty }) {
  return (
    <section className="mt-12">
      <h2 className="font-serif text-2xl text-[#48020C] mb-5">{title}</h2>
      {plans.length === 0 ? (
        <p className="text-[#6E6359]">{empty}</p>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {plans.map((p, i) => <PlanCard key={p.id} plan={p} index={i} />)}
        </div>
      )}
    </section>
  );
}

export default function MyPlans() {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/plans/mine")
      .then(({ data }) => setPlans(data))
      .catch(() => toast.error("Não foi possível carregar os teus planos."))
      .finally(() => setLoading(false));
  }, []);

  const today = new Date().toISOString().slice(0, 10);
  const upcoming = plans.filter((p) => (p.date || "") >= today);
  const past = plans.filter((p) => (p.date || "") < today);

  return (
    <div className="min-h-screen sc-paper">
      <MemberHeader />
      <main data-testid="my-plans-page" className="max-w-6xl mx-auto px-4 sm:px-8 py-12">
        <div className="sc-label text-[#48020C]">A minha agenda pessoal</div>
        <h1 className="font-serif text-4xl sm:text-5xl text-[#26130E] mt-2">Os meus planos</h1>
        {loading ? (
          <p className="text-[#6E6359] mt-10">A carregar…</p>
        ) : plans.length === 0 ? (
          <p className="text-[#6E6359] mt-10">Ainda não te inscreveste em nenhum plano. Vai à <a href="/area" className="underline underline-offset-4 text-[#48020C]">Agenda</a> e junta-te a um!</p>
        ) : (
          <>
            <Section title="Atuais e futuros" plans={upcoming} empty="Sem planos futuros de momento." />
            <Section title="Já participei" plans={past} empty="Ainda não tens planos passados." />
          </>
        )}
      </main>
    </div>
  );
}
